<template>
  <div class="row sidenav">
    <div class="col-3">
      <div class="content-intents__sidebar">
        <ul class="intents-list">
          <li v-for="(lang, key) in languages" :key="key"
              :class="{'active' : selectedIndex == key }">
            <button type="button" @click.prevent="(selectedIndex = key)">
              {{ lang }}
            </button>
          </li>
        </ul>
      </div>
    </div>
    <div class="col-9">
      <FormGroup
        label="Message when the chat crashes"
        tooltip="This text will be sent when an unexpected error occurs during a conversation."
      >
      <textarea
        rows="3"
        type="text"
        placeholder="Something to say"
        v-model="settings.unexpectedErrorMessage[languages[selectedIndex]]"
        :disabled="!hasSufficientPermission"
      />
      </FormGroup>

      <FormGroup
        label="Message when no text/speech received"
        tooltip="This text will be sent when bot received empty string or silence."
      >
      <textarea
        rows="3"
        type="text"
        placeholder="What to say when bot didn't receive any text or speech."
        v-model="settings.messageEmpty[languages[selectedIndex]]"
        :disabled="!hasSufficientPermission"
      />
      </FormGroup>

      <FormGroup
        label="Message when text is only spaces"
        tooltip="This text will be sent when bot received only spaces."
      >
      <textarea
        rows="3"
        type="text"
        placeholder="What to say when bot received only spaces."
        v-model="settings.messageTextEmpty[languages[selectedIndex]]"
        :disabled="!hasSufficientPermission"
      />
      </FormGroup>

      <FormGroup
        label="Message when the bot is not sure"
        tooltip="This text will be sent when the confidence level is between the high & low treshold of the intent."
      >
        <textarea
          rows="3"
          v-model="settings.messageBetweenThreshold[languages[selectedIndex]]"
          placeholder="Something to say"
          :disabled="!hasSufficientPermission"
        />
      </FormGroup>
      <FormGroup
        label="Message when no intent is recognized"
        tooltip="This text will be sent when no intent is recognized."
      >
        <textarea
          rows="3"
          v-model="settings.messageBelowThreshold[languages[selectedIndex]]"
          placeholder="I don't understand"
          :disabled="!hasSufficientPermission"
        />
      </FormGroup>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import GeneralBotSettings from './subtabs/GeneralBotSettings.vue'
import BotIntentRecognizerSettings from './subtabs/BotIntentRecognizerSettings.vue'
import ChatBubble from '@/components/admin/bots/settings/tabs/features/ChatBubble.vue'
import MultiLanguageSettings from '@/components/admin/bots/settings/tabs/features/MultiLanguageSettings.vue'
import GDPR from '@/components/admin/bots/settings/tabs/features/GDPR.vue'
import FormGroup from '@/components/helpers/FormGroup.vue'
import permissionsService from '@/services/tenants/permissions.service'
import { Permissions } from '@common/enums/tenant/user-permissions.enum'

@Component({
  components: {
    FormGroup,
    GDPR, MultiLanguageSettings, ChatBubble,
    GeneralBotSettings,
    BotIntentRecognizerSettings
  }
})
export default class SystemLanguages extends Vue {
  @Prop() readonly settings: any
  @Prop() readonly botName: string;

  private selectedIndex: number = 0
  private hasSufficientPermission = false;

  get permissions () {
    return Permissions
  }

  async beforeMount () {
    this.hasSufficientPermission = await permissionsService.hasPermission(
      this.botName,
      this.permissions.ManageGeneralSettings
    )
  }

  get languages() {
    return this.$store.state.supportedLanguages
  }
}
</script>
